import { BasketItemT } from '../../../../../@types/basketItem.type';
import { OrderSummaryItem } from '../../../../../components/pages/StepSummary/views/OrderSummaryItem';
import { CalculatePriceItemT } from '../../../../../@types/calculatePrice.type';
import React from 'react';

type Props = {
  basket: Array<BasketItemT>;
  prices: Array<CalculatePriceItemT>;
};

const YourOrderInfoBE = ({ basket, prices }: Props) => {
  return (
    <>
      {!!basket.length &&
        basket.map((item: BasketItemT) => {
          const price = prices.find(price => price.itemId === item.orderId);

          return (
            <OrderSummaryItem
              item={item}
              itemDietPrice={price?.totalDietWithoutSideOrdersCost || 0}
              itemDietPricePerDay={price?.perDayDietCost || 0}
              itemSideOrdersPrice={price?.totalSideOrdersCost || 0}
              key={item.orderId}
            />
          );
        })}
    </>
  );
};

export default YourOrderInfoBE;
